import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientDeliverablesPage from "@/pages/client/ClientDeliverablesPage";

export const Route = createFileRoute("/client/contracts/$contractId/deliverables/")({
  head: () => pageHead("Client · Contracts · Deliverables", "AKIVA client · contracts · deliverables portal.", "/client/contracts/$contractId/deliverables", true),
  component: ClientDeliverablesPage,
});
